<template>
  <breadcrumb :title="title" :subTitle="subTitle" :link="link" />
  <div class="container">
    <div class="row">
        <Sidebar />
        <Address />
    </div>
  </div>
</template>

<script>
import breadcrumb from "@/components/layouts/breadcrumb.vue";
import Sidebar from '@/components/layouts/sidebar.vue';
import Address from '@/components/include/profile/address/address.vue';
export default {
  data() {
    return {
      title: this.$t("address"),
      subTitle: "",
      link: "",
    };
  },
  components: { breadcrumb, Sidebar, Address },
};
</script>

<style>
</style>